module.exports = __webpack_public_path__ + "static/media/cbb_app_en.86ce1667.png";